import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { LargeSeperator } from '../../components/common/Seperator'
import config from '../../config'
import { SCHEMES } from '../../constants'
import { SYSTEM_FEATURES } from '../../services/constants'
import { requestCallback } from './actions'
import { requestConfusedQuickQuoteResponse } from '../App/actions'
import ConfusedLoadingBanner from './AnnualInsuranceProviders/ConfusedLoadingBanner'
import ConfusedStaticBanner from './AnnualInsuranceProviders/ConfusedStaticBanner'
import ConfusedRTPBanner from './AnnualInsuranceProviders/ContainerRTPBanner'
import { Container } from './styles'
import { SectionHeading } from '../../components/common/SectionHeading'

const AnnualUpsell = ({
  callbackRequest,
  scheme,
  features,
  actions: { requestCallback, requestConfusedQuickQuoteResponse },
  confusedQuickQuote,
  confusedQuickQuote: {
    OptIn,
    RequestAccepted,
    RequestedDateTime,
    PricingLoaded,
    PricingLoadAttempts,
    Pricing,
  },
  vehicle,
}) => {
  const renderBanner = () =>
    /* eslint-disable react-hooks/rules-of-hooks */
    useMemo(() => {
      if (RequestAccepted) {
        if (PricingLoaded) {
          return (
            <Container>
              <ConfusedRTPBanner
                callbackRequest={callbackRequest}
                requestCallback={requestCallback}
                pricing={Pricing}
                registrationNumber={vehicle.RegistrationNumber}
              />
            </Container>
          )
        } else if (
          PricingLoadAttempts < config.CONFUSED_QUICK_QUOTE_MAX_LOAD_ATTEMPTS
        ) {
          return (
            <Container>
              <ConfusedLoadingBanner
                requestConfusedQuickQuoteResponse={
                  requestConfusedQuickQuoteResponse
                }
                confusedQuickQuoteDateTimeRequested={RequestedDateTime}
                confusedQuickQuoteLoadCount={PricingLoadAttempts}
                registrationNumber={vehicle.RegistrationNumber}
              />
            </Container>
          )
        }
      }

      return (
        <Container>
          <ConfusedStaticBanner
            callbackRequest={callbackRequest}
            requestCallback={requestCallback}
          />
        </Container>
      )
    }, [features, scheme, confusedQuickQuote])

  if (
    features[SYSTEM_FEATURES.UPSELL_CONFUSED_ENABLED] &&
    scheme === SCHEMES.PRIVATE_CAR_SCHEME &&
    OptIn !== null
  ) {
    return (
      <>
        <LargeSeperator />
        <SectionHeading>Annual car insurance</SectionHeading>
        {renderBanner()}
      </>
    )
  }
  return <></>
}

const mapStateToProps = (state) => {
  return {
    callbackRequest: state.policy.callbackRequest,
    scheme: state.scheme.selected,
    features: state.features || {},
    confusedQuickQuote: state.confusedQuickQuote,
    vehicle: state.vehicle.selected,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        requestCallback,
        requestConfusedQuickQuoteResponse,
      },
      dispatch
    ),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AnnualUpsell)
